import { render, staticRenderFns } from "./DataCorrectionRequests.vue?vue&type=template&id=eab57b36&scoped=true&"
import script from "./DataCorrectionRequests.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionRequests.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionRequests.vue?vue&type=style&index=0&id=eab57b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab57b36",
  null
  
)

export default component.exports